export interface Remetente {
  name?: string | null;
  address?: string | null;
}

/**
 * O que vai no avatar de um remetente.
 *
 * Existe para a lista e o painel de leitura nao discordarem. O painel passava o
 * endereco e a lista passava o nome, entao a mesma pessoa aparecia com duas
 * iniciais lado a lado na mesma tela - "Deryk Ribeiro" era DR na lista e RC na
 * leitura. Achado da primeira olhada em caixa real.
 *
 * O nome ganha do endereco porque e o que a pessoa reconhece; o endereco entra
 * quando o remetente nao mandou nome, que e comum em notificacao automatica.
 */
export function nomeNoAvatar(de: Remetente | null | undefined): string {
  const nome = de?.name?.trim() ?? '';
  if (nome !== '') return nome;

  const endereco = de?.address?.trim() ?? '';
  return endereco === '' ? '?' : endereco;
}
